<template>
  <div id="customStyleSection" class="custom-style">
    <div class="content">
      <h1 class="title">{{ translations[lang].title }}</h1>

      <div class="custom-style__wrapper">
        <CustomStyleBlock v-for="(block, index) in blocks[lang]" :key="index" :block="block" :index="index" :lang="lang" />
      </div>

      <div class="trust__button">
        <button v-text="translations[lang].button" :class="{ 'btn-ask-details': lang === 'en' }" class="custom-button" @click="openQuestionForm('question')" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomStyleBlock from '@/Components/En/Common/CustomStyleBlock.vue';

export default {
  name: 'CustomStyle',
  components: {
    CustomStyleBlock,
  },
  props: {
    lang: {
      type: String,
      default: 'en',
    },
    openQuestionForm: {
      default: () => null,
      type: Function,
    },
  },
  data() {
    return {
      blocks: {
        en: [
        {
          title: 'Mixed style',
          description: 'Creating the style regarding your references. Based on AI library',
          url: '/news/unique-style',
        },
        {
          title: 'Outside area',
          description: 'Implementing the exterior and out area - garden, pool and more for you',
        },
        {
          title: 'Window view',
          description: 'Choose the custom view through the window. More then 200 options',
          url: '/news/window-view',
        },
      ],
      ru: [
        {
          title: 'Мой стиль',
          description: 'ИИ соберет стиль по вашему запросу на базе своей библиотеки',
          url: '/news/unique-style',
        },
        {
          title: 'Придомовая',
          description: 'Оформите придомовую, чтобы создать максимальное представление о доме',
          url: '/news',
        },
        {
          title: 'Ваш вид из окна',
          description: 'Выберите подходящий вид из окна или реализуем по вашему запросу новый',
          url: '/news/window-view',
        },
      ],
    },
      translations: {
        en: {
          title: 'Would like your custom style? Go ahead',
          button: 'Ask details',
        },
        ru: {
          title: 'Хотите, чтобы ваше объявление заметили?',
          button: 'Подробнее',
        },
      },
    };
  },
};
</script>
